module.exports = __webpack_public_path__ + "static/media/shuhada.f68f6d0d.png";